"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayMonths = void 0;
var date_fns_1 = require("date-fns");
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = date_fns_1.startOfMonth(month);
    var end = date_fns_1.startOfMonth(date_fns_1.addMonths(start, numberOfMonths));
    var monthsDiff = date_fns_1.differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = date_fns_1.addMonths(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}
exports.getDisplayMonths = getDisplayMonths;
//# sourceMappingURL=getDisplayMonths.js.map